import { render, staticRenderFns } from "./f-box.vue?vue&type=template&id=78d30358&scoped=true&"
import script from "./f-box.vue?vue&type=script&lang=js&"
export * from "./f-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d30358",
  null
  
)

export default component.exports